import { setToken } from "../lib/api";
import { SignatureBg } from "../components/SignatureBg";

export default function SuspendedPage() {
  function signOut() {
    // Clear any stored staff token, then return to the sign-in screen.
    setToken(null);
    window.location.href = "/login";
  }

  return (
    <div className="login-page has-signature-bg">
      <SignatureBg />
      <div className="login-card">
        <div className="brand-lockup login-brand">
          <div className="brand-mark">
            <img src="/brand-mark.png" alt="Alief Dispute Hub" />
          </div>
          <div>
            <strong className="brand-wordmark">Alief Dispute Hub</strong>
            <span>Analyze Smarter. Dispute Better.</span>
          </div>
        </div>
        <h1 id="suspended-heading">Access paused</h1>
        <div role="status" aria-live="polite">
          <p>
            This company&rsquo;s access to the Alief Dispute Hub is currently paused.
            Your work is safe&mdash;nothing has been deleted.
          </p>
          <p>
            Please contact your administrator to restore access. If you believe this
            is a mistake, reach out and they can reactivate the account.
          </p>
        </div>
        <div className="stacked-form" aria-labelledby="suspended-heading">
          <button type="button" className="primary-button wide-button" onClick={signOut}>
            Sign out
          </button>
          <a href="/login" className="ghost-button wide-button">
            Back to sign in
          </a>
        </div>
      </div>
    </div>
  );
}
